import { render, staticRenderFns } from "./UserMescanHeartComparison.vue?vue&type=template&id=749253c6&scoped=true"
import script from "./UserMescanHeartComparison.vue?vue&type=script&lang=js"
export * from "./UserMescanHeartComparison.vue?vue&type=script&lang=js"
import style0 from "./UserMescanHeartComparison.vue?vue&type=style&index=0&id=749253c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749253c6",
  null
  
)

export default component.exports